import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { FBoxContainer, FCheckbox } from '../../../../../components/base';
import {
  FBoxContainer as FBoxContainerV2,
  FCheckbox as FCheckboxV2,
} from '../../../../../components/baseV2';
import { FORTA_BLUE } from '../../../../../utils/colors';
import CheckIconLabel from '../sessionReadOnlyView/components/checkIconLabel/CheckIconLabel';

interface ISynopsisProps {
  isEditable: boolean;
  client_adheres_with_targets_or_goals: boolean;
  no_behavior_issues_or_family_changes: boolean;
  onChange: (key: string, value: any) => void;
  useNewUi: boolean;
}

function Synopsis({
  isEditable,
  client_adheres_with_targets_or_goals,
  no_behavior_issues_or_family_changes,
  onChange,
  useNewUi,
}: ISynopsisProps) {
  const { t } = useTranslation('sessionNotes');

  const synopsisContent = (
    <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', mr: 1 }}>
      {isEditable ? (
        <>
          {useNewUi ? (
            <>
              <FCheckboxV2
                data-testid="checkboxClientadhereswithtargetsorgoals"
                label={t('synopsis.fields.clientAdheresWithTargetsOrGoals')}
                checked={client_adheres_with_targets_or_goals}
                onChange={(e) => {
                  onChange('client_adheres_with_targets_or_goals', e.target.checked);
                }}
                formControlLabelProps={{ sx: { mb: 2 } }}
              />
              <FCheckboxV2
                data-testid="checkboxNobehaviorissuesorfamilychanges"
                label={t('synopsis.fields.noBehaviorIssuesOrFamilyChanges')}
                checked={no_behavior_issues_or_family_changes}
                onChange={(e) => {
                  onChange('no_behavior_issues_or_family_changes', e.target.checked);
                }}
              />
            </>
          ) : (
            <>
              <FCheckbox
                data-testid="checkboxClientadhereswithtargetsorgoals"
                label={t('synopsis.fields.clientAdheresWithTargetsOrGoals')}
                checked={client_adheres_with_targets_or_goals}
                onChange={(e) => {
                  onChange('client_adheres_with_targets_or_goals', e.target.checked);
                }}
                sx={{ mb: 2, fontSize: '16px !important', width: 'fit-content' }}
              />
              <FCheckbox
                data-testid="checkboxNobehaviorissuesorfamilychanges"
                label={t('synopsis.fields.noBehaviorIssuesOrFamilyChanges')}
                checked={no_behavior_issues_or_family_changes}
                onChange={(e) => {
                  onChange('no_behavior_issues_or_family_changes', e.target.checked);
                }}
                sx={{ width: 'fit-content' }}
              />
            </>
          )}
        </>
      ) : (
        <>
          <CheckIconLabel
            sx={{ mt: 0 }}
            label={t('synopsis.fields.clientAdheresWithTargetsOrGoals')}
            checked={client_adheres_with_targets_or_goals}
          />
          <CheckIconLabel
            label={t('synopsis.fields.noBehaviorIssuesOrFamilyChanges')}
            checked={no_behavior_issues_or_family_changes}
          />
        </>
      )}
    </Box>
  );

  if (useNewUi) {
    return (
      <FBoxContainerV2 title={t('synopsis.title')} sx={{ mb: 3 }}>
        {synopsisContent}
      </FBoxContainerV2>
    );
  }

  return (
    <FBoxContainer
      sx={{ height: 'auto', borderRadius: '10px', boxShadow: 'none' }}
      contentStyle={{
        pb: 3,
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', mr: 1 }}>
        <Typography fontSize={21} align="left" mb={4} color={FORTA_BLUE.primary}>
          {t('synopsis.title')}
        </Typography>
        {synopsisContent}
      </Box>
    </FBoxContainer>
  );
}

export default Synopsis;
